// const date = new Date();
// let day = date.getDate();
// let month = date.getMonth() + 1;
// let year = date.getFullYear();
// function getMonthName(monthNumber) {
//   const date = new Date();
//   date.setMonth(monthNumber - 1);

//   return date.toLocaleString("en-US", { month: "long" });
// }
// let currentDate = `${day}${getMonthName(month)}, ${year}`;

// DIN
// UPC
export const reportsRows = [
  {
    id: 1,
    MedicineName: "Alpertine1",
    DIN: "2501130",
    UPC: "2235245",
  },
  {
    id: 2,
    MedicineName: "Alphafilcon",
    DIN: "8470433",
    UPC: "1210920",
  },
  {
    id: 3,
    MedicineName: "Alpha Chymar 250ml",
    DIN: "2501130",
    UPC: "2235245",
  },
  {
    id: 4,
    MedicineName: "Alphafilcon",
    DIN: "8470433",
    UPC: "1210920",
  },
  {
    id: 5,
    MedicineName: "Alpertine 500mg",
    DIN: "2501130",
    UPC: "2235245",
  },
  {
    id: 6,
    MedicineName: "Alphafilcon",
    DIN: "8470433",
    UPC: "1210920",
  },
  {
    id: 7,
    MedicineName: "Alpha Chymar 250ml",
    DIN: "2501130",
    UPC: "2235245",
  },
  {
    id: 8,
    MedicineName: "Alphafilcon",
    DIN: "8470433",
    UPC: "1210920",
  },
  {
    id: 9,
    MedicineName: "Alpertine 500mg",
    DIN: "2501130",
    UPC: "2235245",
  },
  {
    id: 10,
    MedicineName: "Alphafilcon",
    DIN: "8470433",
    UPC: "1210920",
  },
  {
    id: 11,
    MedicineName: "Alpha Chymar 250ml",
    DIN: "2501130",
    UPC: "2235245",
  },
  {
    id: 12,
    MedicineName: "Alphafilcon",
    DIN: "8470433",
    UPC: "1210920",
  },
  {
    id: 13,
    MedicineName: "Alpertine 500mg",
    DIN: "2501130",
    UPC: "2235245",
  },
  {
    id: 14,
    MedicineName: "Alphafilcon",
    DIN: "8470433",
    UPC: "1210920",
  },
  {
    id: 15,
    MedicineName: "Alpha Chymar 250ml",
    DIN: "2501130",
    UPC: "2235245",
  },
];
